import { Button } from '@mui/material'

/**
 * MainButton - Primary action button matching Figma design
 * Used for main CTAs like "Add appointment", "Add client", etc.
 */
function MainButton({
	children,
	startIcon,
	onClick,
	disabled = false,
	fullWidth = false,
	...props
}) {
	return (
		<Button
			variant="contained"
			startIcon={startIcon}
			onClick={onClick}
			disabled={disabled}
			fullWidth={fullWidth}
			disableElevation
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minWidth: 'auto',
				minHeight: 'auto',
				bgcolor: '#E9D8FD',
				color: '#2D3748',
				textTransform: 'none',
				borderRadius: '6px !important',
				padding: '12px 16px !important',
				gap: '10px',
				fontFamily: 'Inter',
				fontWeight: 600,
				fontSize: '14px',
				lineHeight: '1.21em',
				letterSpacing: '-1.786%',
				border: '1px solid #9F7AEA',
				boxShadow: 'none !important',
				'&:hover': {
					bgcolor: '#E9D8FD',
					boxShadow: 'none !important'
				},
				'&:disabled': {
					bgcolor: '#E9D8FD',
					opacity: 0.6
				},
				'& .MuiButton-startIcon': {
					margin: 0
				},
				'& .MuiTouchRipple-root': {
					borderRadius: '6px'
				},
				...props.sx
			}}
			{...props}
		>
			{children}
		</Button>
	)
}

export default MainButton

